import { render, staticRenderFns } from "./PaginationButtons.vue?vue&type=template&id=a7cf4eb6&"
import script from "./PaginationButtons.vue?vue&type=script&lang=js&"
export * from "./PaginationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports